import React from 'react';
import Form from '../Form';
import RegisteredIcon from '../RegisteredIcon';
import { CUSTOM_SOCIAL_ICON_OPTIONS } from 'mayhem-icon-registry';

/**
 * Form component for adding a custom social link
 */
export default function CustomSocialForm({ values, onSubmit, onCancel, onChange, loading }) {
    const fields = [
        {
            name: 'label',
            type: 'text',
            label: 'Label (display name)',
            placeholder: 'e.g., LinkedIn',
            required: true
        },
        {
            name: 'icon',
            type: 'select',
            label: 'Icon',
            options: CUSTOM_SOCIAL_ICON_OPTIONS,
            required: true
        },
        {
            name: 'url',
            type: 'url',
            label: 'URL',
            placeholder: 'https://',
            required: true
        }
    ];

    const currentValues = {
        label: '',
        icon: 'fa-solid fa-link',
        url: '',
        ...values
    };

    return (
        <div className="custom-social-form">
            <Form
                fields={fields}
                values={currentValues}
                onChange={onChange}
                onSubmit={onSubmit}
            >
                {/* Icon preview */}
                <div className="group">
                    <div className="icon-preview">
                        <RegisteredIcon value={currentValues.icon} /> Preview
                    </div>
                </div>
                
                <div className="group">
                    <button type="submit" disabled={loading} className="button">
                        {loading ? 'Saving...' : 'Add Custom Social'}
                    </button>
                    <button type="button" onClick={onCancel} disabled={loading} className="secondary button">
                        Cancel
                    </button>
                </div>
            </Form>
        </div>
    );
}
